<template>
  <div class="telegram-block">
    <div class="telegram-block__icon">
      <TelegramIcon />
    </div>
    <div class="telegram-block__content">
      <span class="telegram-block__text">
        {{ t('news_page_telegram_block.description') }}
      </span>
    </div>
    <button
      class="telegram-block__button"
      @click="emit('move-to-settings')"
    >
      {{ t('news_page_telegram_block.button') }}
    </button>
  </div>
</template>

<script setup>
import { defineEmits } from "vue";
import TelegramIcon from "@/components/Icons/TelegramIcon.vue";
import { t } from "@/controllerLK/AvalLocalization";

const emit = defineEmits(["move-to-settings"]);
</script>

<style lang="scss" scoped>
.telegram-block {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  background: #F4FAFF;
  border-radius: 12px;

  &__icon {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    flex: 1;
    min-width: 0;
  }

  &__text {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #333333;
  }

  &__button {
    flex-shrink: 0;
    padding: 8px 15px;
    background: transparent;
    border: 1px solid #1A64D4;
    border-radius: 8px;
    color: #1A64D4;
    font-weight: 500;
    font-size: 14px;
    line-height: 19.6px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
      border-color: #E0F0FF;
      background: #E0F0FF;
    }
  }
}
</style>
